import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Col, InputGroup, InputGroupAddon, Button, ButtonGroup } from "shards-react";
import { getLinkPDFOrderPracticesFiltered } from "../../core/helper"
import { api } from "../../core/api/api-service";
import LoadingIndicator from "../common/loading-indicator";

const css_loading = {
    "position": "relative",
    "width": "100%",
    "height": "100%",
    "backgroundColor": "#ffffff",
}

export default (props) => {
  const { user } = useSelector( state => state.session)
  const [loading, setLoading] = useState(false)
  let input;

  const handleKeyPress = (event) => {
    if (event.which === 13 || event.keyCode === 13)
      props.onSearch(input.value);
  };

  const handleClick = () => {
    props.onSearch(input.value);
  };

  const handleFilter = (filterType, value = null) => {
    let _filters = props.filters
    let filter_index

    switch (filterType) {
        case 'estado': {
            if(value) {
                filter_index = _filters.estados.findIndex(estado => estado === value)
                filter_index !== -1 ? _filters.estados.splice(filter_index, 1) : _filters.estados.push(value)
                //if(_filters.estados.length === 3) _filters.estados = []
            } else {
                _filters.estados = []
            }
        }
        break;

        case 'asignada': {
            if(value !== null) {
                filter_index = _filters.asignadas.findIndex(asignada => asignada === value)
                filter_index !== -1 ? _filters.asignadas.splice(filter_index, 1) : _filters.asignadas.push(value)
                //if(_filters.asignadas.length === 2) _filters.asignadas = []
            } else {
                _filters.asignadas = []
            }
        }
        break;
    
        default:
            break;
    }
    props.setFilters(_filters)
  }

  const openLinkPracticesSelected = () => {
    const { nroOrden, practices_selected } = props
    let str_practicesIds = ''

    practices_selected.forEach((id, index) => {
        str_practicesIds += id
        if(index !== (practices_selected.length-1)) 
            str_practicesIds += '-'
    });

    api.getOrderLinkPdf(nroOrden, user.userId, str_practicesIds).then( res => {
        if( res.link )
            window.open( res.link, "_blank" )
        setLoading(false)
    })
  }

  return (
    <Row className="pb-3 align-items-end">
    { loading && <div style={css_loading}><LoadingIndicator className="text-center" style={{ "marginTop": "15px", "display": "block" }}/></div>}
      <Col className="col-12 col-md-auto">
        <div className="d-flex">
          <h6 className="mb-2 mb-md-0"><b>Practicas Domiciliarias</b></h6>
        </div>
      </Col>
      {props.practices_selected && props.base_link_pdf && 
      <Col className="col-12 col-md-auto ml-auto">
        <a href={ getLinkPDFOrderPracticesFiltered(props.base_link_pdf, props.practices_selected) } target="_blank" className="noHover btn btn-primary py-2 mr-md-3">Generar PDF<i className="far fa-file-pdf text-danger ml-1" style={{fontSize: 16}}></i></a>
        {/* <button onClick={() => { setLoading(true); openLinkPracticesSelected()} } className='noHover btn btn-primary py-2 mr-md-3'> Generar PDF <i className="far fa-file-pdf text-danger ml-1" style={{fontSize: 16}}></i></button> */}
        {props.filters && props.setFilters &&
        <>
            <ButtonGroup>
                <Button className={`noHover btn ${ !props.filters.estados.find(filter => filter === 'V') ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('estado', 'V') } > Vigentes </Button>
                <Button className={`noHover btn ${ !props.filters.estados.find(filter => filter === 'C') ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('estado', 'C') } > Bajas </Button>
                <Button className={`noHover btn ${ !props.filters.estados.find(filter => filter === 'R') ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('estado', 'R') } > Rechazadas </Button>
                {/* <Button className={`btn ${ props.filters.estados.length > 0 ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('estado') } > Todos </Button> */}
            </ButtonGroup>
            <ButtonGroup className="ml-md-3">
                <Button className={`noHover btn ${ !props.filters.asignadas.find(filter => filter === true) ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('asignada', true) } > Asignadas </Button>
                <Button className={`noHover btn ${ (!props.filters.asignadas.length || (props.filters.asignadas.length === 1 && props.filters.asignadas[0])) ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('asignada', false) } > No asignadas </Button>
                {/* <Button className={`btn ${ props.filters.asignadas.length > 0 ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('asignada') } > Ambas </Button> */}
            </ButtonGroup>
        </>
        }
      </Col>
      }
      {props.filters && props.setFilters && !(props.practices_selected) &&
      <Col className="col-12 col-md-auto ml-auto">
        <ButtonGroup>
            <Button className={`noHover btn ${ !props.filters.estados.find(filter => filter === 'V') ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('estado', 'V') } > Vigentes </Button>
            <Button className={`noHover btn ${ !props.filters.estados.find(filter => filter === 'C') ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('estado', 'C') } > Bajas </Button>
            <Button className={`noHover btn ${ !props.filters.estados.find(filter => filter === 'R') ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('estado', 'R') } > Rechazadas </Button>
            {/* <Button className={`btn ${ props.filters.estados.length > 0 ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('estado') } > Todos </Button> */}
        </ButtonGroup>
        <ButtonGroup className="ml-md-3">
            <Button className={`noHover btn ${ !props.filters.asignadas.find(filter => filter === true) ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('asignada', true) } > Asignadas </Button>
            <Button className={`noHover btn ${ (!props.filters.asignadas.length || (props.filters.asignadas.length === 1 && props.filters.asignadas[0])) ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('asignada', false) } > No asignadas </Button>
            {/* <Button className={`btn ${ props.filters.asignadas.length > 0 ? 'btn-outline-secondary' : 'btn-primary'}`} onClick={ () => handleFilter('asignada') } > Ambas </Button> */}
        </ButtonGroup>
      </Col>
      }
      <Col className="col-12 col-md-auto aling-content-left">
        <InputGroup>
          <input className="form-control" ref={ n => input = n } onKeyPress={(e)=>handleKeyPress(e)} type="text"  placeholder="Buscar"   />
          <InputGroupAddon type="append">
            <Button onClick={ handleClick }  ><i className="material-icons">search</i></Button>
          </InputGroupAddon>
        </InputGroup>
      </Col>
    </Row>
  );
};
